import {NgModule} from "@angular/core";
import {PreloadAllModules, RouterModule, Routes} from "@angular/router";
import {LogoutComponent} from "src/app/logout/logout.component";
import {LoginComponent} from "src/app/login/login.component";
import {OktaCallbackComponent} from "@okta/okta-angular";
import {OktaAuthGuard} from "src/app/common/oktaauth.guard";

const routes: Routes = [
	{path: "", redirectTo: "/home", pathMatch: "full"},

	{path: "callback", component: OktaCallbackComponent},
	{path: "login", component: LoginComponent},
	{path: "logout", component: LogoutComponent},
	{
		path: 'home',
		loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule),
		canActivate: [OktaAuthGuard]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {
		preloadingStrategy: PreloadAllModules, // Load in the background.
		//enableTracing: true, // <-- debugging purposes only
		useHash: false
	})],
	exports: [RouterModule]
})
export class RoutingModule {

}
